module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "street_module",
    style: (_vm.mapStyle)
  }, [_c('div', {
    staticClass: "tab-title"
  }, [_c('span', [_vm._v("街景窗口")]), _vm._v(" "), _c('em', {
    on: {
      "click": _vm.closeStreet
    }
  })]), _vm._v(" "), _c('baidu-map', {
    staticStyle: {
      "height": "100%",
      "box-shadow": "3px 3px 2px #888888"
    },
    attrs: {
      "center": _vm.mapCenter,
      "zoom": 16,
      "scroll-wheel-zoom": _vm.enableScroll
    },
    on: {
      "ready": _vm.ready
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "position": "absolute",
      "left": "0",
      "top": "30px"
    },
    attrs: {
      "id": "panorama"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53483bad","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Map/StreetMap.vue
// module id = 1517
// module chunks = 0